<div class="sp-dialog__min-width sp-dialog__max-width-m">
  <div class="sp-width__full sp-row__end">
    <button
      (click)="onCloseClick()"
      mat-icon-button
      class="sp-icon__button sp-icon__button-accent">
      <mat-icon> clear </mat-icon>
    </button>
  </div>

  <div class="sp-padding__x2">
    <h3 class="sp-color__accent">{{ 'ORDERS.QINETIC_RETRY_CTA' | translate }}</h3>
    <p
      class="sp-color__primary sp-margin__top sp-margin__bottom-x4"
      [innerHTML]="'ORDERS.QINETIC_RETRY_LABEL' | translate : { amount }"></p>

    <app-shared-button
      class="sp-width__full"
      [button_class]="'sp-button__main'"
      [spinner_class]="'sp-spinner__main'"
      [cta]="'GENERAL.CONFIRM_CTA'"
      [is_disabled]="is_reload_running"
      [is_spinner_visible]="is_reload_running"
      (click)="onConfirmClick()"></app-shared-button>
  </div>
</div>
